/**
 * Los números que se ven arriba de la cobranza de un trámite, sacados del detalle del cobro que
 * devuelve el backend.
 *
 * El saldo NUNCA se calcula acá: llega calculado del backend (monto total − pagos), mismo criterio
 * que VistaDetalladaAtencionCobro. Acá solo se juntan cosas que el backend ya dejó a mano.
 *
 * Las cuotas anuladas (las que se reemplazaron al reprogramar el plan) no cuentan para nada: siguen
 * en la lista como historial, pero no son parte del plan vigente.
 */
/**
 * Un solo pago = pagó todo: no se lleva saldo ni monto pactado, así que mostrar "Pagado $0" o un saldo
 * engaña. En todos lados se muestra PAGO_TODO en lugar de los montos (pedido del estudio, 20-oct-2026).
 */
export const PAGO_TODO = 'PAGO TODO';
export const esPagoTodo = (cobro) => cobro?.tipoPago === 'UN_SOLO_PAGO';

export function resumenCobro(cobro) {
    const cuotas = (cobro.cuotas || []).filter((c) => !c.anulada);
    const pagos = cobro.pagos || [];

    const totalPagado = pagos.reduce((suma, p) => suma + Number(p.monto || 0), 0);
    const montoPactado = cobro.montoTotal ?? null;

    // La próxima es la de vencimiento más cercano entre las que todavía no se pagaron. Si hay una
    // vencida, es esa (la fecha más vieja): lo que más importa ver es que hay una cuota atrasada.
    // Las fechas vienen como AAAA-MM-DD, así que ordenarlas como texto es ordenarlas por fecha.
    const proxima = cuotas
        .filter((c) => !c.pagada && c.fechaVencimiento)
        .sort((a, b) => a.fechaVencimiento.localeCompare(b.fechaVencimiento))[0] || null;

    return {
        montoPactado,
        totalPagado,
        saldo: cobro.saldo ?? null,
        cantidadCuotas: cuotas.length,
        cuotasPagadas: cuotas.filter((c) => c.pagada).length,
        totalCuotas: cuotas.reduce((suma, c) => suma + Number(c.monto || 0), 0),
        proximoVencimiento: proxima
            ? { fecha: proxima.fechaVencimiento, numero: proxima.numero, monto: proxima.monto, vencida: !!proxima.vencida }
            : null,
        // Solo para la barra de avance: sin monto pactado no hay sobre qué calcular. No pasa de 100
        // aunque se haya cobrado de más.
        porcentajePagado: montoPactado > 0 ? Math.min(100, Math.round((totalPagado * 100) / montoPactado)) : null,
    };
}
